/**
 * The method of calculating discounted payment amounts
 * tag: 40744
 * @readonly
 * @enum {number} (int)
 */
export enum PaymentStreamDiscountType {
  /** Standard */
  Standard = 0,
  /** Forward Rate Agreement (FRA) */
  FRA = 1,
}
